import type { PropsWithChildren } from 'react';
import { createContext } from 'react';
import { LoggerService } from '../services';

export const LoggerContext = createContext<LoggerService>(new LoggerService('core'));

type LoggerProviderProps = PropsWithChildren<{ value: LoggerService }>;

export function LoggerProvider(props: LoggerProviderProps) {
  return <LoggerContext.Provider {...props} />;
}
